import React, { useState } from 'react';
import { useConnect } from '@stacks/connect-react';
import { deruptFeedContractAddress } from '../../lib/constants';
import { someCV, uintCV } from '@stacks/transactions';
import { network } from '../../services/auth';

const ContractCosts = () => {
    const [chimeStxCost, setChimeStxCost] = useState('');
    const [chimeFtCost, setChimeFtCost] = useState('');
    const [likeFtCost, setLikeFtCost] = useState('');
    const [disLikeFtCost, setDisLikeFtCost] = useState('');

    const { doContractCall } = useConnect();

    const handleOnTextChange = (e) => {
        const { target: { value }, target: { name } } = e;
        switch (name) {
            case 'chimeStxCost':
                setChimeStxCost(value)
                break;
            case 'chimeFtCost':
                setChimeFtCost(value)
                break;
            case 'likeFtCost':
                setLikeFtCost(value)
                break;
            case 'disLikeFtCost':
                setDisLikeFtCost(value)
                break;
            default:
                break;
        }
    }

    const setCost = () => {
        const txOptions = {
            contractAddress: deruptFeedContractAddress.split('.')[0],
            contractName: deruptFeedContractAddress.split('.')[1],
            functionName: 'set-cost',
            functionArgs: [
                someCV(uintCV(chimeStxCost)),
                someCV(uintCV(chimeFtCost)),
                someCV(uintCV(likeFtCost)),
                someCV(uintCV(disLikeFtCost))
            ],
            validateWithAbi: true,
            network,
            onFinish: ({ txId }) => {
                console.log(txId);
            }
        };
        doContractCall(txOptions);
    }

    return (
        <div>
            {/* Values should be input as 'uValue', examples are in placeholders */}
            <div>
                <input className="settings-field" type="number" name='chimeStxCost' placeholder='chime-stx-cost..u1000000' onChange={handleOnTextChange} />
            </div>

            <div>
                <input className="settings-field" type="number" name='chimeFtCost' placeholder='chime-ft-cost..u1000000' onChange={handleOnTextChange} />
            </div>

            <div>
                <input className="settings-field" type="number" name='likeFtCost' placeholder='like-ft-cost..u1000000' onChange={handleOnTextChange} />
            </div>

            <div>
                <input className="settings-field" type="number" name='disLikeFtCost' placeholder='dislike-ft-cost..u10000000' onChange={handleOnTextChange} />
            </div>

            <div>
                <button className="settings-button" onClick={setCost}>Update Costs</button>
            </div>
        </div>
    );
}

export default ContractCosts;
